import { Alert } from '@tempmee/react';
import { BANNER_COPY } from '../constants';

export const InfoBanner = () => (
  <Alert severity="info" data-testid="worker-type-info-banner" description={BANNER_COPY} />
);
